function isFunction(element: unknown): boolean {
  return 'function' === typeof element
}

export default isFunction
